import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-camera",
  "use": "spr-camera-usage",
  "viewBox": "0 0 22 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 14\" id=\"spr-camera\"><defs><path id=\"spr-camera_a\" d=\"M55 528.87v8.26a1 1 0 0 1-1.55.83l-3.45-2.3V538c0 1.18-.77 1.97-1.97 2H35c-1.18 0-1.97-.77-2-1.97V528c0-1.18.78-1.97 1.98-2H48c1.18 0 1.97.77 2 1.97v2.36l3.45-2.3a1 1 0 0 1 1.55.84zm-2 1.87l-3 2v.52l3 2zm-18 7.25l13 .01v-10H35.01zM45 536h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z\" /></defs><use fill=\"#cd9932\" xlink:href=\"#spr-camera_a\" transform=\"translate(-33 -526)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/camera.svg
// module id = 246
// module chunks = 0